import { z } from 'zod';

export const NlpGraphQueryRequest = z.object({
  text: z.string(),
});

export type NlpGraphQueryRequest = z.infer<typeof NlpGraphQueryRequest>;

export const NlpGraphQueryResult = z.object({
  graphName: z.string(),
  xAxisName: z
    .string()
    .describe('The prettified name that describes what the x axis represents'),
  yAxisName: z
    .string()
    .describe('A prettified name that describes what the y axis represents'),
  xAxisElementColumn: z
    .string()
    .describe(
      'The column name that is used in the output of the query to label each graph properly on the x-axis',
    ),
  valueColumn: z
    .string()
    .describe(
      'The column name that is used in the output of the query to label the values of the y-axis',
    ),
  query: z.string().describe('The SQL query that was generated'),
});

export type NlpGraphQueryResult = z.infer<typeof NlpGraphQueryResult>;
